import React, {Component} from "react";
import 'pretty-checkbox/src/pretty-checkbox.scss';

class PrettyCheckbox extends Component {

    PrettyCheckboxOn = (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.5 14C13.3125 14 14 13.3438 14 12.5V1.5C14 0.6875 13.3125 0 12.5 0H1.5C0.65625 0 0 0.6875 0 1.5V12.5C0 13.3438 0.65625 14 1.5 14H12.5ZM6.09375 10.9375C5.90625 11.1562 5.5625 11.1562 5.375 10.9375L2.125 7.6875C1.9375 7.5 1.9375 7.1875 2.125 7L2.84375 6.28125C3.03125 6.09375 3.34375 6.09375 3.53125 6.28125L5.75 8.46875L10.4375 3.78125C10.625 3.59375 10.9375 3.59375 11.125 3.78125L11.8438 4.5C12.0312 4.6875 12.0312 5 11.8438 5.1875L6.09375 10.9375Z"
                fill="#2B82F7"/>
        </svg>
    );

    PrettyCheckboxOff = (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.5 0H1.5C0.65625 0 0 0.6875 0 1.5V12.5C0 13.3438 0.65625 14 1.5 14H12.5C13.3125 14 14 13.3438 14 12.5V1.5C14 0.6875 13.3125 0 12.5 0ZM12.3125 12.5H1.6875C1.5625 12.5 1.5 12.4375 1.5 12.3125V1.6875C1.5 1.59375 1.5625 1.5 1.6875 1.5H12.3125C12.4062 1.5 12.5 1.59375 12.5 1.6875V12.3125C12.5 12.4375 12.4062 12.5 12.3125 12.5Z"
                fill="#2B82F7"/>
        </svg>
    );

    render() {
        const {checked, disabled, children, onCheckChange, name} = this.props;

        return (
            <>
                <div className="pretty p-svg p-curve">
                    <input type="checkbox" name={name} onChange={onCheckChange} checked={checked} disabled={disabled}/>
                    <div className="state p-success">
                        {(checked ? this.PrettyCheckboxOn : this.PrettyCheckboxOff)}
                        {children ? (
                            <label>{children}</label>
                        ) : null}
                    </div>
                </div>
            </>
        );
    }
}

export default PrettyCheckbox;